<!-- eslint-disable vue/valid-v-for -->
<template>
  <el-container>
    
    <el-header style="padding: 0; min-height: 30px;">
      <el-page-header @back="goBack()" :content="title">
      </el-page-header>
    </el-header>
    <el-main>
      <el-form ref="testimonialForm" :model="form" :rules="rules" label-width="120px" class="demo-ruleForm t_center"
               align="left" label-position="left">
        <el-form-item label="序号" prop="orderNum">
          <el-input v-model="form.orderNum" placeholder="序号"></el-input>
        </el-form-item>
        <el-form-item label="头像:" prop="photoUrl">
            <el-upload
                v-model="form.photoUrl"
                :action="uploadURL"
                :headers="headers"
                name="upfile"
                list-type="picture-card"
                :on-preview="handlePictureCardPreview"
                :on-remove="pictureHandleRemove"
                :on-change="pictureOnChange"
                :on-success="pictureHandleSuccess"
                :before-upload="imageBeforeAvatarUpload"
                :limit="2"
                :file-list="pictureFileList"
                :show-file-list="true" >
                  <i class="el-icon-plus"></i>
            </el-upload>
            <el-dialog :visible.sync="dialogVisible" size="tiny">
              <img width="100%" :src="dialogImageUrl" alt="">
            </el-dialog>
        </el-form-item>
        <el-form-item label="姓名" prop="studentName">
          <el-input v-model="form.studentName" placeholder="姓名"></el-input>
        </el-form-item>
        <el-form-item label="英文姓名" prop="studentNameEn">
          <el-input v-model="form.studentNameEn" placeholder="英文姓名"></el-input>
        </el-form-item>
        <el-form-item label="职业" prop="occupation">
          <el-input v-model="form.occupation" placeholder="职业"></el-input>
        </el-form-item>
        <el-form-item label="英文职业" prop="occupationEn">
          <el-input v-model="form.occupationEn" placeholder="英文职业"></el-input>
        </el-form-item>
        <el-form-item label="所学项目:" :inline="true" prop="programNameId" style="width: 100%">
            <el-cascader
                expand-trigger="hover"
                change-on-select="true"
                size="small"
                :options="array1"
                :props="{ value: 'ccId', label: 'ccName'}"
                v-model="selectedOrgCategory"
                @change="changeCategory">
            </el-cascader>
          </el-form-item>
        <el-form-item label="感言" prop="testimonial">
          <el-input type="textarea" v-model="form.testimonial"></el-input>
        </el-form-item>
        <el-form-item label="英文感言" prop="testimonialEn">
          <el-input type="textarea" v-model="form.testimonialEn"></el-input>
        </el-form-item>
        <el-form-item class="cls-col" label="首页是否显示" prop="isShowIndex">
          <el-radio-group v-model="form.isShowIndex">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item class="cls-col" label="是否可见" prop="isVisiable">
          <el-radio-group v-model="form.isVisiable">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="国籍:" prop="nationality">
            <el-select
                v-model="form.nationality"
                clearable
                filterable
                placeholder="国籍"
                style="width: 100%"
            >
            <el-option v-for="a in nationalityList" :label="a.zhName" :value="a.nationalityId" :key="a.id"></el-option>
            </el-select>
        </el-form-item>
        <el-form-item label="感言视频:" prop="introduceVideo">
                  <el-upload
                    v-model="form.introduceVideo"
                    name="upfile"
                    style="margin-bottom: 10px;"
                    class="upload-demo"
                    :headers="headers"
                    :action="uploadURL"
                    :on-preview="handleauditionUploadPreview"
                    :on-remove="handleauditionUploadRemove"
                    :before-remove="beforeauditionUploadRemove"
                    :on-success="HandleauditionUploadSuccess"
                    multiple
                    :limit="1"
                    :on-exceed="handleauditionUploadExceed"
                    :file-list="auditionUploadfileList">
                    <el-button size="small" type="primary">上传视频</el-button>
                    <div slot="tip" class="el-upload__tip">只能上传视频文件</div>
                  </el-upload>
                </el-form-item>
        <el-form-item label="视频封面图:" prop="introduceVideoFengmian">
            <el-upload
                v-model="form.introduceVideoFengmian"
                name="upfile"
                :action="uploadURL"
                :headers="headers"
                list-type="picture-card"
                :on-preview="handlePictureCardPreview"
                :on-remove="pictureHandleRemove"
                :on-change="pictureOnChange"
                :on-success="fengmianHandleSuccess"
                :on-error="onError"
                :before-upload="imageBeforeAvatarUpload"
                :limit="1"
                :on-exceed="exceed"
                :file-list="fengmianFileList"
                :show-file-list="true">
              <i class="el-icon-plus"></i>
            </el-upload>
            <el-dialog :visible.sync="dialogVisible" size="tiny">
              <img width="100%" :src="dialogImageUrl" alt="">
            </el-dialog>
        </el-form-item>
        <el-form-item align="center">
          <el-button @click="reset">重置</el-button>
          <el-button type="primary" @click="testimonialSave">保存</el-button>
        </el-form-item>
      </el-form>
    </el-main>
  </el-container>
</template>

<script>
  import https from '@/https.js';
  import {dateFormat} from '@/api/utils.js';
  const toolbarOptions = [
    ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
    [{'header': 1}, {'header': 2}],               // custom button values
    [{'list': 'ordered'}, {'list': 'bullet'}],
    [{'indent': '-1'}, {'indent': '+1'}],          // outdent/indent
    [{'direction': 'rtl'}],                         // text direction
    [{'size': ['small', false, 'large', 'huge']}],  // custom dropdown
    [{'header': [1, 2, 3, 4, 5, 6, false]}],
    [{'color': []}, {'background': []}],          // dropdown with defaults from theme
    [{'font': []}],
    [{'align': []}],
    ['link', 'image'],
    ['clean']

  ];
  
  export default {
    components: {
      dateFormat,
  },
    data() {
      return {
        loginOrgCode: '',
        testimonialName: '填写学生感言',
        orgEdit: false,
        showThird: false,
        attachmentList: [],//附件列表
        pictureFileList: [],
        fengmianFileList:[],
        dialogVisible: false,
        loaded: false,
        dialogImageUrl: '',
        reFresh: true,
        orgCode: '',
        categoryOptions: [],
        choseCommodityIds: [],
        array1 : [],
        array2 : [],
        choseCommodity: false,
        fileName:'',
        form: {
          photoUrl:'',
          ccId: '',
          studentName: '',
          studentNameEn:'',
          occupation:'',
          occupationEn: '',
          orderNum:'',
          programNameId:'',
          programCategoryId: '',
          testimonial:'',
          testimonialEn:'',
          isShowIndex: 1,
          indexTestimonial:'',
          indexTestimonialEn:'',
          isVisiable: 1,
          introduceVideo:'',
          introduceVideoFengmian: '',
          nationality:'',
          id: '',
          orgCode: '',
        },
        courseOptions: [],
        hidePictureUpload: false,
        selectedCourse: [],
        selectedCategory: [],
        selectedOrgCategory: [],
        categoryOptionsMap: {},
        categoryOrgOptions: [],
        auditionUploadfileList:[],
        categoryOrgOptionsMap: {},
        options: {
          img: '',                         //裁剪图片的地址
          info: true,                      //裁剪框的大小信息
          outputSize: 1,                   // 裁剪生成图片的质量
          outputType: 'jpeg',              //裁剪生成图片的格式
          canScale: false,                 // 图片是否允许滚轮缩放
          autoCrop: true,                  // 是否默认生成截图框
          fixed: false,                    //是否开启截图框宽高固定比例
          fixedNumber: [16, 9]              //截图框的宽高比例
        },
        nationalityList: [],
        videoFlag: false, //是否显示进度条
        videoUploadPercent: 0, //进度条的进度，
        duration: "", //视频时长
        rules: {
          orderNum: [
            {required: true, message: '请输入数字序号', trigger: 'blur'}
          ],
          studentName: [
            {required: true, message: '请输入学生姓名', trigger: 'blur'}
          ],
          studentNameEn: [
            {required: true, message: '请输入英文姓名', trigger: 'blur'}
          ],
          occupation: [
            {required: true, message: '请输入职业', trigger: 'blur'}
          ],
          occupationEn: [
            {required: true, message: '请输入英文职业', trigger: 'blur'}
          ],
          nationality: [
            {required: true, message: '请选择国籍', trigger: 'blur'}
          ],
          isShowIndex: [
            {required: true, message: '请选择是否首页显示', trigger: 'blur'}
          ],
          isVisiable: [
            {required: true, message: '请输入是否可见', trigger: 'blur'}
          ],
          programNameId: [
            {required: true, message: '请选择分类', trigger: 'blur'}
          ]

        },
        uploadURL: "",
        headers: {
          Authentication: localStorage.getItem('token')
        },

      };
    },
    methods: {
    // handleInput(value) {
    //   console.log("value:",value);
    //   const reg = /^[\d\.]+$/;
    //   if (value && !reg.test(value)) {
    //     this.orderNum = value.replace(/[^\d\.]/g, '');
    //   }
    // },
      handleauditionUploadExceed(files, fileList) {
        this.$message.warning(`当前限制选择 3 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
      },
      HandleauditionUploadSuccess(response) {
        this.auditionUploadfileList = [];
        if(response.code == 200) {
          // this.pathName = response.data.fileName;
          this.form.introduceVideo = response.data.resourceUrl;
          let file = {
          name: response.data.fileName,
          url: response.data.resourceUrl
          };
          this.auditionUploadfileList.push(file);
          this.options.img = file.url;
          this.hidePictureUpload = true;
        } else {
          this.$message.error('上传图片失败!');
          this.hidePictureUpload = false;
        }
      },
      beforeauditionUploadRemove(file, fileList) {
        return this.$confirm(`确定移除 ${ file.name }？`);
      },
      handleauditionUploadRemove(file, fileList) {
        console.log(file, fileList);
      },
      handleauditionUploadPreview(file) {
        console.log(file);
      },
      exceed(res, file) {
        console.log(res);
      },
      selectCategoryData(val) {
        if(val == undefined) {
          val = '';
        }
        let params = {
          orgCode: val
        };
        this.https.fetchPost('/courseCategoryInfo/selectListRecursion', params, 'json').then((data) => {
          this.categoryOrgOptions = [];       
          let code = data.data.code;
          let msg = data.data.msg;
          if(code == 200) {
            if(data.data.data != null) {
              this.categoryOrgOptions = data.data.data;
              for (let index = 0; index < this.categoryOrgOptions.length; index++) {
                   this.array2=[];
                for(let ind=0;ind<this.categoryOrgOptions[index].children.length;ind++){
                   let arr = {
                    ccId: this.categoryOrgOptions[index].children[ind].ccId,
                    ccName:this.categoryOrgOptions[index].children[ind].ccName
                  };
                   this.array2.push(arr);
                }
                this.array1.push({"ccId":this.categoryOrgOptions[index].ccId,"ccName":this.categoryOrgOptions[index].ccName,"children":this.array2}); 
              }
            }
          } else {
            this.$message({
              type: 'info',
              message: '加载失败:' + msg
            });
          }
        }).catch(err => {
          console.log(err);
          this.$message.error('网络错误');
        });
      },
      //加载本部分类
      loadCourseCategory() {
        let params = {
          orgCode: this.$store.state.eblcuOrg
        };
        if(this.loginOrgCode == 'blcuonline') {
          params.orgCode = 'blcuonline'
        }
        this.https.fetchPost('/courseCategoryInfo/selectListRecursion', params, 'json').then((data) => {
          let code = data.data.code;
          let msg = data.data.msg;
          if (code == 200) {
            this.categoryOptions = data.data.data;
          } else {
            this.$message({
              type: 'info',
              message: '加载失败:' + msg
            });
          }

        }).catch(err => {
          console.log(err);
          this.$message.error('网络错误');
        });
      },
      changeCategory(value) {
      },
      // /managerNationality/getList
      getNationality() {
        https.fetchGet('/managerNationality/getList', {}, 'form').then((data) => {
          let code = data.data.code;
          let msg = data.data.msg;
          if (code == 200) {
            if(data.data.data) {
              this.nationalityList = data.data.data;
            }
          } else {
            this.$message({
              type: 'info',
              message: '加载失败:' + msg
            });
          }
        })
            .catch((err) => {
              console.log(err);
              this.$message.error('网络错误');
            });
      },
      imageBeforeAvatarUpload(file) {
        const isJPG = file.type === 'image/jpeg'  || file.type === 'image/png' || file.type === 'image/bmp';
        const isLt2M = file.size / 1024 / 1024 < 5;
        if (!isJPG) {
          this.$message.error('上传头像图片只能是 JPG 格式!');
        }
        if (!isLt2M) {
          this.$message.error('上传头像图片大小不能超过 5MB!');
        }
        return isJPG && isLt2M;
      },
      onError (err, file, fileList) {
          console.log("err---",err);

      },
      pictureHandleSuccess(response) {
        this.pictureFileList = [];
        if(response.code == 200) {
          this.form.photoUrl = response.data.resourceUrl;
          let file = {
            name: response.data.fileName,
            url: response.data.resourceUrl
          };
          this.pictureFileList.push(file);
          this.options.img = file.url;
          this.isShowCropper = true;
          this.hidePictureUpload = true;
        } else {
          this.$message.error('上传图片失败!');
          this.hidePictureUpload = false;
        }
        
      },
      fengmianHandleSuccess(response, file, fileList) {
        this.fengmianFileList = [];
        if(response.code == 200) {
          this.form.introduceVideoFengmian = response.data.resourceUrl;
          let file = {
            name: response.data.fileName,
            url: response.data.resourceUrl
          };
          this.fengmianFileList.push(file);
          this.options.img = file.url;
          this.isShowCropper = true;
          this.hidePictureUpload = true;
        } else {
          this.$message.error('上传图片失败!');
          this.hidePictureUpload = false;
        }
        
      },
      pictureOnChange(file, fileList) {
        this.hidePictureUpload = fileList.length >= this.pictureLimitCount;
      },
      pictureHandleRemove(file, fileList) {
        this.hidePictureUpload = fileList.length >= this.pictureLimitCount;
      },
      handlePictureCardPreview(file) {
        this.dialogImageUrl = file.url;
        this.dialogVisible = true;
      },
      selectItem(value){
        var aid =value;
         console.log(aid);
      },
      goBack() {
        this.$router.go(-1);
      },
      //保存资源数据
      testimonialSave() {
      if(this.selectedOrgCategory.length > 0) {
          this.form.programCategoryId = this.selectedOrgCategory[this.selectedOrgCategory.length-2];
          this.form.programNameId = this.selectedOrgCategory[this.selectedOrgCategory.length-1];
        }
        let params = this.form;
        this.$refs['testimonialForm'].validate((valid) => {
          if (!valid) {
            this.$message.error('请正确填写信息！');
            return false;
          } else {
            let url = '/testimonial/addTestimonial';
            if (this.form.id) {
              url = '/testimonial/updateTestimonial';
            }
            https.fetchPost(url, params, 'json').then((data) => {
              let code = data.data.code;
              let msg = data.data.msg;
              if (code == 200) {
                this.$message({
                  message: '操作成功',
                  type: 'success'
                });
                this.$router.push('/testimonial/testimonial');
              } else {
                this.$message({
                  type: 'info',
                  message: '操作失败：' + msg
                });
              }
            }).catch(err => {
                  this.$message.error('网络错误');
                }
            );
          }
        });
      },
      reset() {
        this.$refs['testimonialForm'].resetFields();
        // this.form.createTime = dateFormat(new Date(this.form.createTime));
      },

      changeOrg() {
        this.searchCourseType();
    
        this.form.id = "";
        this.form.ccId = "";
      },
    },
    created: function() {
      this.getNationality();
      this.loginOrgCode = this.$store.state.orgCode;
      this.uploadURL = this.https.baseURL + '/resources/updateResourceFile';
      this.selectCategoryData(this.loginOrgCode);
      let dataForm = this.$route.params;
      if (dataForm.id) {
        this.title = '修改学生感言';
        this.orgEdit = true;
        // dataForm.createTime = dateFormat(new Date(dataForm.createTime))
        this.form = dataForm;
        if(this.form.photoUrl){
         let pictureFile = {
              name: this.form.photoUrl,
              url: this.form.photoUrl
            };
            this.pictureFileList.push(pictureFile);
        }
        if(this.form.introduceVideo){
              let pictureFile = {
              name: this.form.introduceVideo,
              url: this.form.introduceVideo
            };
            this.auditionUploadfileList.push(pictureFile);
        }
        if(this.form.introduceVideoFengmian){
        let pictureFile = {
              name: this.form.introduceVideoFengmian,
              url: this.form.introduceVideoFengmian
            };
            this.fengmianFileList.push(pictureFile);
        }
        if(this.form.programCategoryId != null) {
            this.selectedOrgCategory.push(this.form.programCategoryId);
            this.selectedOrgCategory.push(this.form.programNameId);
        }
      } else {
        this.title = '添加学生感言';
      }
    },
    
  };
</script>

<style>
    ::v-deep input::-webkit-outer-spin-button,
      ::v-deep input::-webkit-inner-spin-button {
        -webkit-appearance: none !important;
      }
      ::v-deep input[type='number'] {
      -moz-appearance: textfield !important;
      }
  .avatar-uploader {
    width: 500px;
  }
  
  .t_top {
    margin-bottom: 10px;
  }
  
  .t_center {
    width: 80%;
    margin: 0 auto;
  }
  
  .t_center1 {
    width: 100%;
    margin: 0 auto;
  }
  
  .avatar-uploader {
    width: 95%;
  }
  
  .ql-editor {
    min-height: 300px;
  }
  
  .hide .el-upload--picture-card {
    display: none;
  }
  
  .el-col-11 {
    width: 30%;
    margin-right: 0px;
    padding-right: 0px;
  }
  
  .el-upload-list__item {
    width: 50%;
  }

.avatar-uploader-icon {
  border: 1px dashed #d9d9d9 !important;
}
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9 !important;
  border-radius: 6px !important;
  position: relative !important;
  overflow: hidden !important;
}
.avatar-uploader .el-upload:hover {
  border: 1px dashed #d9d9d9 !important;
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 300px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 300px;
  height: 178px;
  display: block;
}
.hide .el-upload--picture-card {
    display: none;
  }
  .avatar-uploader {
    width: 500px;
  }
  
  .t_top {
    margin-bottom: 10px;
  }
  
  .t_center {
    width: 80%;
    margin: 0 auto;
  }
  
  .t_center1 {
    width: 100%;
    margin: 0 auto;
  }
  
  .avatar-uploader {
    width: 95%;
  }
  
  .ql-editor {
    min-height: 300px;
  }
  
  .hide .el-upload--picture-card {
    display: none;
  }
  
  .el-col-11 {
    width: 30%;
    margin-right: 0px;
    padding-right: 0px;
  }
  
  .el-upload-list__item {
    width: 50%;
  }


  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;}
</style>
